import { useState, type ReactNode } from 'react';

import { Campo, Painel } from '../../comum';
import type { PropsSecao } from './comum';

/**
 * As travas. Mexer aqui muda o que o produto pode escrever no KACE.
 */
export function SecaoSeguranca({ c, podeEditar, acao, salvar }: PropsSecao): ReactNode {
  const [seguranca, setSeguranca] = useState(c.seguranca);

  return (
    <Painel titulo="Segurança" sub="A trava de escrita é a decisão mais importante desta tela.">
      <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
        <input
          type="checkbox"
          checked={seguranca.escritaLiberada}
          disabled={!podeEditar}
          onChange={(e) => setSeguranca({ ...seguranca, escritaLiberada: e.target.checked })}
        />
        <span>
          <strong>Liberar escrita no KACE</strong>
          <span className="ajuda">
            Enquanto desligado, o produto não executa script, não abre chamado e não altera nada no
            appliance. Ligue quando confiar no que ele está propondo.
          </span>
        </span>
      </label>

      <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
        <input
          type="checkbox"
          checked={seguranca.cookieSeguro}
          disabled={!podeEditar}
          onChange={(e) => setSeguranca({ ...seguranca, cookieSeguro: e.target.checked })}
        />
        <span>
          <strong>Cookie somente por HTTPS</strong>
          <span className="ajuda">
            Ligue apenas se este produto for servido por HTTPS. Em HTTP, o navegador descarta o
            cookie e o login para de funcionar sem mensagem de erro.
          </span>
        </span>
      </label>

      <Campo
        rotulo="Duração da sessão (horas)"
        ajuda="De 1 a 24. As permissões ficam congeladas no cookie por este tempo."
      >
        <input
          type="number"
          min={1}
          max={24}
          value={seguranca.horasSessao}
          disabled={!podeEditar}
          onChange={(e) => setSeguranca({ ...seguranca, horasSessao: Number(e.target.value) })}
        />
      </Campo>

      <button
        className="primario"
        disabled={acao.executando || !podeEditar}
        onClick={() => salvar('seguranca', seguranca, 'Segurança')}
      >
        Salvar
      </button>
    </Painel>
  );
}
